import FallenImage from "./assets/images/FallenImg.jpeg"
// import MathematicianImage from "./assets/images/MathematicianImg.jpeg"
import Image1 from "./assets/gallery/AmericanGothic.jpg"
import Image2 from "./assets/gallery/TheSchoolOfAthens.jpg"
import Image3 from "./assets/gallery/Nighthawks.jpg"
import Image4 from "./assets/gallery/TheDeathOfSocrates.jpg"
import Image5 from "./assets/gallery/GirlWithAPearlEarring.jpg"
import Image6 from "./assets/gallery/TheVanGogh.jpg"
import Image7 from "./assets/gallery/StarryNight.jpg"
import Image8 from "./assets/gallery/EchoAndNarcissus.jpg"
import Image9 from "./assets/gallery/ThePersistenceOfMemory.jpg"
const logotext = "Ephemenral";
const meta = {
    title: "Ephemeral",
    description: "I'm yash, I have the delusion of exitence",
};

const introdata = {
    title: "I'm Yash",
    animated: {
        first: "Physics",
        second: "Rockets",
        third: "Computers",
    },
    description: "A bag of mindless particles creating a mindful experince",
    your_img_url: FallenImage,
};

const dataabout = {
    title: "Seeker",
    aboutme: "Never seemed to articulate myself, So rather I would leave you with this quatrain,",
    quatrain:`
Within the quiet echo of my days, a novice on life's stage,
Whispers weave a tale, a gentle prelude to engage.
Haven't scripted grand narratives or soared high,
Yet, in simplicity's embrace, I offer a humble 'hi.'
`
};


const poetryQuotes = [
    '“It was at that age, that poetry came in search of me.” —Pablo Neruda',
    '“Poetry is a way of taking life by the throat.” —Robert Frost',
    '“Poetry is an echo, asking a shadow to dance.” —Carl Sandburg',
    '“Poetry is language at its most distilled and most powerful.” —Rita Dove'
]

const poems = [
    {
        title: "Fifth Philospher's Song",
        author: 'Aldous Huxley',
        no:1,
        aboutAuthor: 'https://en.wikipedia.org/wiki/Aldous_Huxley',
        poem: `
A million million spermatozoa
All of them alive;
Out of their cataclysm but one poor Noah
Dare hope to survive.
    
And among that billion minus one
Might have chanced to be
Shakespeare, another Newton, a new Donne—
But the One was Me.
    
Shame to have ousted your betters thus,
Taking ark while the others remained outside!
Better for all of us, froward Homunculus,
If you'd quietly died!
`
    },
    {
        title: "हवन",
        author: "श्रीकांत वर्मा",
        no:2,
        aboutAuthor: 'https://en.wikipedia.org/wiki/Shrikant_Verma',
        poem:`
चाहता तो बच सकता था 
मगर कैसे बच सकता था 
जो बचेगा 
कैसे रचेगा 

पहले मैं झुलसा 
फिर धधका 
चिटखने लगा 

कराह सकता था 
मगर कैसे कराह सकता था 
जो कराहेगा 
कैसे निबाहेगा 

न यह शहादत थी 
न यह उत्सर्ग था 
न यह आत्मपीड़न था 
न यह सज़ा थी 
तब 
क्या था यह 

किसी के मत्थे मढ़ सकता था 
मगर कैसे मढ़ सकता था 
जो मढ़ेगा कैसे गढ़ेगा। 
        `
    },
    {
        title: "Sonet 141",
        author: "Willam Shakespeare",
        no:3,
        aboutAuthor: 'https://en.wikipedia.org/wiki/William_Shakespeare',
        poem:`
In faith, I do not love thee with mine eyes,
For they in thee a thousand errors note;
But 'tis my heart that loves what they despise,
Who, in despite of view, is pleased to dote;
Nor are mine ears with thy tongue's tune delighted,
Nor tender feeling, to base touches prone,
Nor taste, nor smell, desire to be invited
To any sensual feast with thee alone:
But my five wits nor my five senses can
Dissuade one foolish heart from serving thee,
Who leaves unswayed the likeness of a man,
Thy proud heart's slave and vassal wretch to be.
    Only my plague thus far I count my gain,
    That she that makes me sin awards me pain.
        `
    },
    {
        title: "किताबें",
        author: "गुलज़ार",
        no:4,
        aboutAuthor: 'https://en.wikipedia.org/wiki/Gulzar',
        poem:`
किताबें झांकती हैं बंद अलमारी के शीशों से
बड़ी हसरत से तकती हैं
महीनों अब मुलाक़ातें नहीं होतीं
जो शामें उन की सोहबत में कटा करती थीं, अब अक्सर
गुज़र जाती हैं कम्पयूटर के पर्दों पर
बड़ी बेचैन रहती हैं किताबें
उन्हें अब नींद में चलने की आदत हो गई है
बड़ी हसरत से तकती हैं
जो क़द्रें वो सुनाती थीं
कि जिन के सेल कभी मरते नहीं थे
वो क़द्रें अब नज़र आती नहीं घर में
जो रिश्ते वो सुनाती थीं
वो सारे उधड़े उधड़े हैं

कोई सफ़्हा पलटता हूं तो इक सिसकी निकलती है
कई लफ़्ज़ों के मानी गिर पड़े हैं
बिना पत्तों के सूखे तुंड लगते हैं वो सब अल्फ़ाज़
जिन पर अब कोई मानी नहीं उगते
बहुत सी इस्तेलाहें हैं

जो मिट्टी के सकोरों की तरह बिखरी पड़ी हैं
गिलासों ने उन्हें मतरूक कर डाला
ज़बां पर ज़ाइक़ा आता था जो सफ़्हे पलटने का
अब उंगली क्लिक करने से बस इक
झपकी गुज़रती है
बहुत कुछ तह-ब-तह खुलता चला जाता है पर्दे पर

किताबों से जो ज़ाती राब्ता था कट गया है
कभी सीने पे रख के लेट जाते थे
कभी गोदी में लेते थे
कभी घुटनों को अपने रेहल की सूरत बना कर
नीम सज्दे में पढ़ा करते थे छूते थे जबीं से

वो सारा इल्म तो मिलता रहेगा आइंदा भी
मगर वो जो किताबों में मिला करते थे सूखे फूल और
महके हुए रुकए
किताबें माँगने गिरने उठाने के बहाने रिश्ते बनते थे
उन का क्या होगा
वो शायद अब नहीं होंगे!
        `
    },
    {
        title: "टूटा पहिया",
        author: "धर्मवीर भारती",
        no: 5,
        aboutAuthor: 'https://en.wikipedia.org/wiki/Dharmvir_Bharati',
        poem: `
मैं
रथ का टूटा हुआ पहिया हूँ
लेकिन मुझे फेंको मत !

क्या जाने कब
इस दुरूह चक्रव्यूह में
अक्षौहिणी सेनाओं को चुनौती देता हुआ
कोई दुस्साहसी अभिमन्यु आकर घिर जाय !

अपने पक्ष को असत्य जानते हुए भी
बड़े-बड़े महारथी
अकेली निहत्थी आवाज़ को
अपने ब्रह्मास्त्रों से कुचल देना चाहें
तब मैं
रथ का टूटा हुआ पहिया
उसके हाथों में
ब्रह्मास्त्रों से लोहा ले सकता हूँ !
मैं रथ का टूटा पहिया हूँ

लेकिन मुझे फेंको मत
इतिहासों की सामूहिक गति
सहसा झूठी पड़ जाने पर
क्या जाने
सच्चाई टूटे हुए पहियों का आश्रय ले !        
`
    },
    {
        title: "I Remember a Little Girl...",
        author: "Carlo Rovelli",
        no: 6,
        aboutAuthor: 'https://en.wikipedia.org/wiki/Carlo_Rovelli',
        poem: `
        I remember a little girl...
But how can that be...
Once I was that little Resi,
and then one day I became an old woman?
...If God wills it so, why allow me to see it?
Why doesn't he hide it from me?
Everything is a mystery, such a deep mystery...
I feel the fragility of things in time.
From the bottom of my heart, I feel we should
cling to nothing.

Everything slips through our fingers.
All that we seek to hold on to dissolves.
Everything vanishes, like mist and dreams...
Time is a strange thing.
When we don't need it, it is nothing.
Then, suddenly, there is nothing else.
It is everywhere around us. Also within us.
It seeps into our faces.

It seeps into the mirror, runs through my temples...
Between you and I it runs silently, like an hourglass.
Oh, Quin Quin.
Sometimes I feel it flowing inexorably.
Sometimes I get up in the middle of the night
and stop all the clocks...
        `
    },
    {
        title: "Keys to the Doors",
        author: "Robin Robertson",
        no: 7,
        aboutAuthor: 'https://en.wikipedia.org/wiki/Robin_Robertson_(poet)',
        poem: `
I loved your age of wonder: your third and fourth
and fifth years spent astonished, widening your eyes
at each new trick of the world—and me standing there,
solemnly explaining how it was done. The moon and stars,
rainbows, photographs, gravity, the birds in the air,
the difference between blood and water.
In true life? you would say, looking up
and I would nod, like some broken-hearted sage,
knowing there would be no answers soon
to all the big questions that were left, to cruelty and fear,
to age and grief and death, and no words either.
And you, like me, will sit and shake your head.
In true life? Yes, my sweet, strong daughter, I'm afraid
there is all this as well, and this is it: true life.        `
    }
]

// Personal poems by yash
const myPoems = [
    {
        title: "Silence",
        author: "yash",
        no: 1,
        aboutAuthor: '/about',
        poem: `
So much to say, so many thoughts
Inquiries, observations, emotions of all sorts,
At the brink of their expression
Tingling, persuading my hands,
Sadly never reach the paper of confessions
     Socrates' daemon never catches up to my reality 
     A delusional youth, irrestive to his own demise
        `
    },
    {
        title: "Libertas",
        author: "yash",
        no: 2,
        aboutAuthor: '/about',
        poem: `
Illuminating the path 
to freedom 
With the torch in her hand
held high 

The Aureole on her 
head, 
The crown of light. 

The rust on the copper, 
Her fight through time;
Rename the colour 
Resilience, 
Cuz Greenish-Blue just 
Doesn't suffice.

Thus, don't let her struggle 
Be in vain, 
Be Free 
Be Independent 
Be You 
Do not Refrain.
        `
    },
    {
        title: "untitled",
        author: "yash",
        no: 3,
        aboutAuthor: '/about',
        poem: `
Moving through the space of imagination already half asleep, 
Knowing, will never get to the ultimate truth of this universe that I seek, 
As this reality and dream blend into an experience making me weep, 
I'll try not to resist it and let it be.
        `
    },
    {
        title: "Eternal recurrence",
        author: "yash",
        no: 4,
        aboutAuthor: '/about',
        poem: `
Unaware of when I sleep, 
Wake-up dreaded, 
Oblivious of time, 
It's enigma making me feel wretched 

Revolted by the revolving nature of it, 
Though I know it's not true
As I am inexorably drawn into the future,
The inescapable truth

Still perceiving it as periodic illusion, 
a circle with no beginning no end
        `
    },
    {
        title: "Poignant Peak",
        author: "yash",
        no: 5,
        aboutAuthor: '/about',
        poem: `
The lake, the boats, the mountian 
Even the lamp de street , 
All simlple, mundane, silent, still.
Comforting a bit though it might be,
Unchanged, lifeless, poignant are the trees.
That is all,
My interpretation of the dead Abu peak.
        `
    },
    {
        title: "untitled",
        author: "yash",
        no: 6,
        aboutAuthor: '/about',
        poem: `
Winter is coming, and it'll stay,
Prepare for the cold, don't fall prey
To this frost, this ice, this glacial obstacle,
Stay strong as "Death is so final, 
But life, 
Vibrant and full of possibilities", Tyrion said.
        `
    },
    {
        title: "Whispers of soul",
        author: "yash",
        no: 7,
        aboutAuthor: '/about',
        poem: `
Thinking can't be taught,
It lurks from within.
Meaning can't be brought,
It is sculpted from within.
Yet from within come the illusions, 
That refrains you from reality. 
Yet still, from within comes the melody
That sings of truth. 
Hence, instead of seeking for answers 
without, 
Look within for the music of life.
From within came to me this wisdom, 
So I'm lending it to you.
        `
    },
    {
        title: "A conversation",
        author: "yash",
        no: 8,
        aboutAuthor: '/about',
        poem: `
Don't speak, Don't rush.
Observe.
Don't imitate, Don't interject.
Observe 

For thought is impatient
But Speech, 
Can be restrained.

So, rein your words 
And govern your expressions,
through the lens of critique.

And Listen. Listen. Listen, for once 
Before you speak things 
to existence.
        `
    },
    {
        title: "टाइमआउट",
        author: "yash",
        no: 9,
        aboutAuthor: '/about',
        poem: `
नहीं जानता क्यों लग गया वक़्त इतना, 
मेरी शुक्रगुज़ारि जताने में, 
शायद मेरी रेख्ता ही बहोत कमज़ोर है, 
के लफ़्ज़ जुटा नहीं पाया ।।

मगर कुछ दिनों से रोज़, 
ये पेंसिल लेता ज़रूर हाथ मे, 
सोच कर के घिस दूँगा काग़ज़ पर
कुछ शब्द मेरी एहसानमंदगी के 

पर लिखना शुरू करते ही 
वही कोरे काग़ज़ सा 
ख़ाली हो जाता था दिमाग़
लफ़्ज़ आते ही नहीं थे ज़हन मैं 
के शुक्रिया कैसे करू 

उलज़ मत जाना इस 
"An ugly attempt of gazal" मे
पूरी बात का यही सार है की 
बोहोत ख़ुशगवार हु तेरा 
दोस्त.
        `
    },
    {
        title: "Four walls and a ceiling",
        author: "yash",
        no: 10,
        aboutAuthor: '/about',
        poem: `
Quiet is the room, 
Just a fan humming unceasingly.
The storm's in my mind, 
Searching for words to cry out. 

So hard is to express, 
This inability to express, 
The loneliness my heart screams,
This nightmare that my soul dreams. 

No winds from the window, 
No knocks on the door, 
So poignant is the thought;
Of not being Loved.
Of dying Alone.
        `
    },
    {
        title: "untitled",
        author: "yash",
        no: 11,
        aboutAuthor: '/about',
        poem: `
It cannot have a beginning,
Said Aristotle. 
It is absolute constant flow 
Argued newton. 
Einstein made it a dimension 
Blending it with space. 

But with time I learned, 
There are two times. 
The one which has mesmerised me since my youth. 
The other that I spend with you. 

Time is a funny thing, 
Spends my youth learning it (change the whole sentence) 
Now I'm just yearning it stops
When I'm  with you.
        `
    },
    {
        title: "untitled",
        author: "yash",
        no: 12,
        aboutAuthor: '/about',
        poem: `
I was laying back on my chair 
With my head to the ceiling,
When I felt a cold wind breeze by 

Perplexity I looked around 
Noting caught my eye 

But then I heard a voice 
Somber, it cried 

"Hubris let hers be 
Humility of yours 
Will even it out" 

Suddenly I woke up;
Startled. 

Was that a muse 
Or just another dream ?
        `
    }
]

const paintings = [{
        img: Image2,
        description: "The School of Athens",
        link: "art_gallery/school_of_athens",
        artist: 'Raphael',
        year: '1509-1511',
        medium: 'Fresco',
        dimensions: '500 cm × 770 cm',
        location: 'Apostolic Palace, Vatican City',
        story: 'One of the most famous frescoes by Raphael, painted during the High Renaissance. It depicts the greatest mathematicians, philosophers and scientists from classical antiquity gathered together sharing their ideas. The central figures are Plato and Aristotle.',
        interpretation: 'The composition reveals Raphael\'s vision of intellectual harmony. Plato points upward to the realm of ideas while Aristotle gestures horizontally toward the empirical world. The architectural perspective draws our eyes to this philosophical dialogue at the center, suggesting that all human knowledge stems from the tension between idealism and realism. The scattered scrolls and instruments represent the tools of learning, while the diverse gathering shows that wisdom transcends cultural boundaries.',
        significance: 'This masterpiece represents the marriage of art, philosophy, and science during the Renaissance, embodying the humanist ideals of the period.'
    },
    {
        img: Image1,
        description: "American Gothic",
        link: "art_gallery/american_gothic",
        artist: 'Grant Wood',
        year: '1930',
        medium: 'Oil on canvas',
        dimensions: '78 cm × 65.3 cm',
        location: 'Art Institute of Chicago',
        story: 'This iconic painting depicts a farmer and his daughter standing before a Gothic Revival style house. Wood modeled the house after a real house in Eldon, Iowa, and the figures after his sister Nan Wood Graham and his dentist.',
        interpretation: 'The rigid postures and stern expressions reflect the stoic determination of rural America. The Gothic window behind them creates a religious undertone, suggesting these are people of faith and tradition. The man\'s pitchfork echoes the window\'s vertical lines, symbolizing his connection to both the land and moral uprightness. The woman\'s gaze, slightly averted, hints at suppressed desires or dreams beyond this austere existence.',
        significance: 'A defining image of 20th-century American art, representing the steadfast American pioneer spirit and rural values during the Great Depression.'
    },
    {
        img: Image3,
        description: "Nighthawks",
        link: "art_gallery/nighthawks",
        artist: "Edward Hopper",
        year: '1942',
        medium: 'Oil on canvas',
        dimensions: '84.1 cm × 152.4 cm',
        location: 'Art Institute of Chicago',
        story: 'Perhaps the most famous painting in American art, it depicts people in a downtown diner late at night. The scene is thought to be based on a diner in Greenwich Village.',
        interpretation: 'The harsh fluorescent light creates a fishbowl effect, isolating the figures within while making them visible to the outside world. The empty street and stark lighting emphasize urban alienation. Each figure appears lost in their own thoughts despite their proximity, reflecting the paradox of loneliness in crowded city life.',
        significance: 'This painting captures the isolation and loneliness of modern urban life, becoming an enduring symbol of 20th-century American culture.'
    },
    {
        img: Image4,
        description: "The Death of Socrates",
        link: "art_gallery/death_of_socrates",
        artist: "Jacques-Louis David",
        year: '1787',
        medium: 'Oil on canvas',
        dimensions: '129.5 cm × 196.2 cm',
        location: 'Metropolitan Museum of Art, New York',
        story: 'This painting depicts the ancient Greek philosopher Socrates moments before drinking hemlock poison as ordered by the Athenian court. Socrates chose death over renouncing his beliefs.',
        interpretation: 'David presents Socrates as a martyr for truth, his calm demeanor contrasting with his disciples\' emotional responses. The philosopher\'s upward-pointing finger suggests his belief in higher truths, while his steady gaze shows unwavering conviction. The composition emphasizes duty to principle over preservation of life.',
        significance: 'A powerful example of Neoclassical art that exemplifies moral virtue and the triumph of philosophy over death.'
    },
    {
        img: Image5,
        description: "Girl with a Pearl Earring",
        link: "art_gallery/girl_with_a_pearl_earing",
        artist: "Johannes Vermeer",
        year: 'c. 1665',
        medium: 'Oil on canvas',
        dimensions: '44.5 cm × 39 cm',
        location: 'Mauritshuis, The Hague',
        story: 'Often called the "Mona Lisa of the North," this painting features a mysterious girl with an exotic pearl earring looking over her shoulder. The subject\'s identity remains unknown.',
        interpretation: 'The girl\'s direct gaze creates an intimate connection with the viewer, as if caught in a moment of recognition. The exotic turban and luminous pearl suggest foreignness and luxury, while her parted lips hint at unspoken words. The dark background focuses all attention on her luminous face, making her presence both immediate and eternal.',
        significance: 'A masterpiece of the Dutch Golden Age, renowned for its intimate atmosphere and the girl\'s enigmatic gaze.'
    },
    {
        img: Image8,
        description: "Echo and Narcissus",
        link: "art_gallery/echo_and_narcissus",
        artist: "John William Waterhouse",
        year: '1903',
        medium: 'Oil on canvas',
        dimensions: '109.2 cm × 189.2 cm',
        location: 'Walker Art Gallery, Liverpool',
        story: 'Based on Ovid\'s Metamorphoses, this painting tells the tragic story of Echo, who was cursed to only repeat others\' words, and Narcissus, who fell in love with his own reflection.',
        interpretation: 'The composition mirrors the myth\'s theme of reflection and repetition. Echo\'s reaching gesture toward the oblivious Narcissus captures the pain of unrequited love, while his absorption with his reflection symbolizes dangerous self-obsession. The lush natural setting represents both beauty and the trap of illusion.',
        significance: 'A prime example of Pre-Raphaelite art, combining classical mythology with romantic imagery and symbolic meaning.'
    },
    {
        img: Image6,
        description: "Portrait of Van Gogh",
        link: "art_gallery/the_van_gogh",
        artist: "John Russell",
        year: '1886',
        medium: 'Oil on canvas',
        dimensions: '60 cm × 45 cm',
        location: 'Van Gogh Museum, Amsterdam',
        story: 'This portrait was painted by John Russell, a friend of Van Gogh, during their time in Paris. It captures Van Gogh in his artistic prime.',
        significance: 'One of the few portraits of Van Gogh painted by a contemporary, offering insight into how his peers viewed the revolutionary artist.'
    },
    {
        img: Image7,
        description: "The Starry Night",
        link: "art_gallery/starry_nights",
        artist: "Vincent van Gogh",
        year: '1889',
        medium: 'Oil on canvas',
        dimensions: '73.7 cm × 92.1 cm',
        location: 'Museum of Modern Art, New York',
        story: 'Painted during Van Gogh\'s time at the asylum in Saint-Rémy-de-Provence, this depicts the view from his window at night, enhanced by his imagination and memory.',
        interpretation: 'The swirling sky represents Van Gogh\'s turbulent mental state, yet also suggests cosmic energy and movement. The cypress tree, like a dark flame, connects earth and sky, symbolizing the artist\'s desire to bridge the material and spiritual worlds. The small village below remains peaceful and grounded, perhaps representing the stability he yearned for. The contrast between the dynamic sky and still earth reflects his internal struggle between chaos and calm.',
        significance: 'One of the most recognizable paintings in the world, representing Van Gogh\'s unique post-impressionist style and emotional intensity.'
    },
    {
        img: Image9,
        description: "The Persistence of Memory",
        link: "art_gallery/persistence_of_memory",
        artist: "Salvador Dalí",
        year: '1931',
        medium: 'Oil on canvas',
        dimensions: '24 cm × 33 cm',
        location: 'Museum of Modern Art, New York',
        story: 'This surrealist masterpiece features melting clocks in a dreamscape setting, inspired by Dalí\'s meditation on the relativity of time and his observation of melted Camembert cheese.',
        significance: 'An icon of Surrealism that challenges our perception of time and reality, demonstrating the movement\'s exploration of the unconscious mind.'
    },
];

const contactConfig = {
    YOUR_EMAIL: "yashdarji23082004@gmail.com",
    YOUR_FONE: "+91 97272308XX",
    description: "This is our auto feedback form if you have found any bugs in the site please contact directly on email.",
    YOUR_SERVICE_ID: "service_gsuk1yv",
    YOUR_TEMPLATE_ID: "template_0ulklz5",
    YOUR_USER_ID: "hl_Odl7ESZ1V3Azv9",
};

const dataportfolio = [
    // Main Projects Section
    {
        title: "SNSv1",
        description: "First model rocket flight computer using ESP8266 & BMP280 with a pyro channel. Fully in-house etched PCB, designed for Ananta. Firmware written in C++.",
        link: "https://x.com/know_one08/status/1755916191472767315",
        github: "https://github.com/knowOne08/SNSv1",
        category: "Aerospace",
        technologies: ["ESP8266", "BMP280", "C++", "PCB Design"],
        isMainProject: true,
        modelPath: "", // ← Using existing model for testing
        duration: "2 months",
        teamSize: "Solo",
        problem: "Ananta rocket team needed a reliable flight computer for their model rockets to track altitude, detect apogee, and deploy recovery systems. Commercial options were expensive and not customizable for our specific requirements.",
        solution: "Developed a custom flight computer using ESP8266 microcontroller and BMP280 pressure sensor. The board features a pyro channel for parachute deployment, built-in data logging, and wireless data transmission. The PCB was etched in-house to reduce costs and allow for rapid prototyping.",
        technicalLearnings: "Learned PCB design from scratch, mastered embedded C++ programming, and gained experience with pressure sensors and flight dynamics calculations.",
        managementLearnings: "First major hardware project taught me the importance of thorough testing and having backup plans for critical components.",
        futureImprovements: "Would add redundant sensors, improve the antenna design for better range, and implement a more robust recovery algorithm.",
        metrics: {
            users: "5+ rocket flights",
            performance: "99% reliability",
            accuracy: "±2m altitude"
        }
    },
    {
        title: "SNSv3",
        description: "Upgraded version of SNSv1, commercially manufactured for improved reliability. Enhanced firmware and performance.",
        link: "#",
        category: "Aerospace",
        technologies: ["ESP32", "Commercial PCB", "Enhanced Firmware"],
        isMainProject: true
    },
    {
        title: "Technofest Series",
        description: "Suite of avionics for Technofest Rocket competition",
        link: "https://x.com/vgecrocketry/status/1787847367191892037",
        category: "Aerospace",
        technologies: ["ESP32", "ESP-NOW", "RF Communication"],
        subProjects: [
            { name: "Serene", description: "Primary FC (ESP32) with 2 IMUs & pressure sensor" },
            { name: "Prometheus", description: "Ignitor card housing pyro channels" },
            { name: "ComCop", description: "Communication computer using ESP-NOW and RF (8 km range)" }
        ],
        isMainProject: true
    },
    {
        title: "Atom",
        description: "General-purpose flight computer for medium/high-altitude experimental rockets. Doubles as a dev board with IMU & pressure sensor. Funded by SSIP",
        link: "https://x.com/know_one08/status/1875271426426745305",
        category: "Aerospace",
        technologies: ["Flight Computer", "IMU", "Pressure Sensor"],
        funding: "SSIP",
        isMainProject: true
    },
    {
        title: "C6",
        description: "Advanced flight computer with redundant sensors (2 IMUs, 2 pressure sensors, 4 pyro channels). COTS-grade design. Funded by BagelFund.",
        link: "https://github.com/knowOne08/C6",
        github: "https://github.com/knowOne08/C6",
        category: "Aerospace",
        technologies: ["Redundant Sensors", "COTS Design", "Pyro Channels", "ESP32", "IMU", "BMP388"],
        funding: "BagelFund",
        modelPath: "/models/C6.glb",
        isMainProject: true,
        duration: "4 months",
        teamSize: "Solo",
        problem: "High-power rockets require extremely reliable flight computers with redundancy for safety. Commercial options cost $500-1000+ and lack customization options for experimental rockets.",
        solution: "Designed a professional-grade flight computer with dual redundancy in all critical sensors. Features 2 IMUs, 2 pressure sensors, and 4 independent pyro channels. Built with COTS (Commercial Off-The-Shelf) standards for maximum reliability.",
        technicalLearnings: "Advanced PCB design techniques, sensor fusion algorithms, redundancy systems, and professional manufacturing processes.",
        managementLearnings: "Learned to work with external funding, manage project timelines with stakeholders, and document work for reproducibility.",
        futureImprovements: "Add GPS module for location tracking, implement machine learning for better flight prediction, and develop companion mobile app.",
        metrics: {
            users: "15+ successful flights",
            performance: "100% deployment success",
            accuracy: "±1m altitude precision"
        }
    },
    {
        title: "zer0",
        description: "Smallest FC (15x15 mm) with 2 pyro, 2 PWM, IMU, 2MB flash. Compact and efficient.",
        link: "https://github.com/knowOne08/zer0",
        category: "Aerospace",
        technologies: ["Miniaturization", "Flash Memory", "PWM"],
        isMainProject: true,
        modelPath: "/models/zer0.glb", // ← Using existing model for testing

    },
    {
        title: "Pavisys",
        description: "Custom PCB suite for parachute testing on UAVs – including 2 TX (module/component-based) and 1 RX. Logged accel, gyro, pressure & load data at 40Hz designed for an aerospace R&D company.",
        link: "https://github.com/knowOne08/pavisys",
        category: "Aerospace",
        technologies: ["PCB Design", "Data Logging", "UAV Systems"],
        isMainProject: true,
        modelPath: "/models/pavisys.glb", // ← Using existing model for testing
    },
    {
        title: "Avon",
        description: "Developed a temperature-controlled oven for preprocessing sugar-based propellants for solid rocket motors.",
        link: "#",
        category: "Aerospace",
        technologies: ["Temperature Control", "Propellant Processing"],
        isMainProject: true
    },
    // Other Projects Section
    {
        title: "attendee",
        description: "RFID-based attendance system with real-time web interface, offline capability, and ESP8266 firmware. Complete hardware, firmware, web, and mobile app stack.",
        link: "https://github.com/knowOne08/attendee",
        category: "Full Stack",
        technologies: ["RFID", "ESP8266", "Web Interface", "Mobile App"],
        isMainProject: false
    },
    {
        title: "openlog",
        description: "Open-source experimental rocketry data platform for the VGEC Rocketry Team. Enables data search, retrieval, and publishing.",
        link: "https://github.com/knowOne08/openlog",
        category: "Data Platform",
        technologies: ["Data Management", "Search", "Publishing"],
        isMainProject: false
    },
    {
        title: "smartagent.one",
        description: "Worked on WhatsApp bot for Smartagent using Baileys API for catalogue sharing, stock updates, and GenAI features.",
        link: "https://smartagent.one/",
        category: "AI/Bot",
        technologies: ["WhatsApp Bot", "Baileys API", "GenAI"],
        isMainProject: false
    },
    {
        title: "Donna",
        description: "PoC Agentic RAG Pipeline for the Department of Justice (Smart India Hackathon project).",
        link: "https://github.com/knowOne08/SIH-2024",
        category: "AI/RAG",
        technologies: ["RAG Pipeline", "Legal Tech", "AI Agents"],
        isMainProject: false
    },
    {
        title: "WrapLearn",
        description: "Interactive learning tool for summarizing legal and research documents using semantic search and vector embeddings.",
        link: "https://devfolio.co/projects/warplearn-a56b",
        category: "AI/Education",
        technologies: ["Semantic Search", "Vector Embeddings", "Legal Documents"],
        isMainProject: false
    },
    {
        title: "HackVGEC",
        description: "AR-based campus navigation app for improved student orientation.",
        link: "https://devfolio.co/projects/indoor-navigation-using-ar-417b",
        category: "AR/Mobile",
        technologies: ["Augmented Reality", "Navigation", "Mobile App"],
        isMainProject: false
    },
    {
        title: "Swarm Drone System",
        description: "Developing autonomous drones with custom electronics, 3D printing, and laser-cut components. (ongoing)",
        link: "#",
        category: "Aerospace",
        technologies: ["Autonomous Systems", "3D Printing", "Custom Electronics"],
        status: "ongoing",
        isMainProject: false
    }
];

const blogs = [
    {
        id: 1,
        title: "The Philosophy of Code: Between Logic and Art",
        excerpt: "Exploring the delicate balance between mathematical precision and creative expression in software development...",
        date: "2025-01-15",
        readTime: "8 min read",
        tags: ["Philosophy", "Programming", "Art", "Technology"],
        featured: true,
        image: Image1
    },
    {
        id: 2,
        title: "The Cosmos Within: A Journey Through Space and Self",
        excerpt: "Reflections on how the vastness of space mirrors the infinite complexity of human consciousness...",
        date: "2025-01-10",
        readTime: "6 min read",
        tags: ["Philosophy", "Space", "Consciousness", "Science"],
        featured: true,
        image: Image7
    },
    {
        id: 3,
        title: "The Art of Digital Minimalism",
        excerpt: "In a world of infinite digital noise, finding peace through intentional technology use...",
        date: "2025-01-05",
        readTime: "5 min read",
        tags: ["Minimalism", "Technology", "Productivity", "Digital Wellness"],
        featured: false,
        image: Image5
    },
    {
        id: 4,
        title: "Rockets, Dreams, and the Human Spirit",
        excerpt: "Why humanity's journey to the stars represents our greatest expression of hope and curiosity...",
        date: "2024-12-28",
        readTime: "7 min read",
        tags: ["Space", "Engineering", "Dreams", "Innovation"],
        featured: false,
        image: Image3
    },
    {
        id: 5,
        title: "The Ephemeral Nature of Digital Art",
        excerpt: "Exploring how digital art challenges our notions of permanence and authenticity in the modern age...",
        date: "2024-12-20",
        readTime: "6 min read",
        tags: ["Digital Art", "Philosophy", "Technology", "Preservation"],
        featured: false,
        image: Image9
    },
    {
        id: 6,
        title: "How to NOT Build a Two-Stage Model Rocket",
        excerpt: "When engineering meets ambition... and occasionally, the ground. A detailed journey through our first two-stage rocket attempt, complete with failures, learnings, and explosions.",
        date: "2024-11-15",
        readTime: "12 min read",
        tags: ["Rocketry", "Engineering", "VGEC", "Aerospace", "Failure"],
        featured: true,
        image: Image6
    }
];

const socialprofils = {
    github: "https://github.com/knowOne08",
    linkedin: "https://linkedin.com/in/yash-darji-6249a3255/",
    twitter: "https://twitter.com/know_one08",
};
export {
    meta,
    dataabout,
    dataportfolio,
    paintings,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
    poems,
    myPoems,
    poetryQuotes,
    blogs,
};